// src/features/landing/application/useLandingContent.js
import { useMemo } from "react";
import { landingRepository } from "../infrastructure/landingStaticRepository";

/**
 * 랜딩 페이지에서 필요한 도메인 데이터를 가져오는 UseCase/Hook
 */
export function useLandingContent() {
    const heroSlides = useMemo(
        () => landingRepository.getHeroSlides(),
        []
    );

    return {
        heroSlides,
    };
}
